import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CrmUserProfile } from "@/services/adminCrm";

interface Props {
  profile: CrmUserProfile;
}

function val(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === "") return "\u2014";
  return String(v);
}

export function UserProfileSection({ profile }: Props) {
  const fields: { label: string; value: string }[] = [
    { label: "Grad Year", value: val(profile.gradYear) },
    { label: "Gender", value: val(profile.gender) },
    { label: "Home State", value: val(profile.homeState) },
    { label: "GPA", value: val(profile.gpa) },
    { label: "SAT", value: val(profile.satScore) },
    { label: "ACT", value: val(profile.actScore) },
    { label: "Handedness", value: val(profile.handedness) },
    { label: "Cell", value: val(profile.cellNumber) },
    {
      label: "Preferred Majors",
      value: profile.preferredMajors.length > 0 ? profile.preferredMajors.join(", ") : "\u2014",
    },
    { label: "Swing Coach", value: "\u2014" },
    { label: "Swing Video URL", value: val(profile.swingVideoUrl) },
    { label: "Instagram", value: val(profile.instagramProfile) },
    { label: "Twitter", value: val(profile.twitterHandle) },
    { label: "YouTube", value: val(profile.youtube) },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Profile</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
          {fields.map(f => (
            <div key={f.label} className="flex justify-between py-1">
              <span className="text-muted-foreground">{f.label}</span>
              <span className="text-right truncate max-w-[60%]">{f.value}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
